import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

const PublicRoute = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  }, [location?.pathname]);

  return <Outlet />;
};

export default PublicRoute;
